import React  from "react";
import SingleProduct from "../../../shared-components/SingleProduct/SingleProduct";
import ProfileCard from "../../../shared-components/ProfileCard/ProfileCard";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Author() {
 
  AnimationFileLoader();

  return (
    <>
 
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Author Profile */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row mb-50">
            <div className="col-lg-9 order-1 order-lg-0">
              {/* Tab Buttons */}
              <ul className="nav tab-buttons justify-content-center justify-content-lg-start">
                <li>
                  <button
                    className="active select-rounded text-uppercase lg"
                    data-bs-toggle="tab"
                    data-bs-target="#collected"
                  >
                    On Sale
                  </button>
                </li>
                <li>
                  <button
                    className="select-rounded text-uppercase lg"
                    data-bs-toggle="tab"
                    data-bs-target="#created"
                  >
                    Creations
                  </button>
                </li>
                <li>
                  <button
                    className="select-rounded text-uppercase lg"
                    data-bs-toggle="tab"
                    data-bs-target="#favorited"
                  >
                    Collections
                  </button>
                </li>
              </ul>
              {/* End Tab Buttons */}
            </div>
            <div className="col-lg-3 order-0 order-lg-1">
              <div className="d-flex justify-content-center justify-content-lg-end mb-4 mb-lg-0">
                <select className="select-rounded lg">
                  <option value="offers">Recent Active</option>
                  <option value="offers_received">Year 2016</option>
                  <option value="offers_made">Year 2017</option>
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8 mb-60 mb-lg-0">
              <div className="tab-content">
                <div className="tab-pane fade show active" id="collected">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Single Product */}

                      <SingleProduct
                        classList="single-product mb-30"
                        productName="Colorful Abstract Painting"
                        productPrice="0.69  ETH"
                        info="2 to 100"
                      />
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}

                      <SingleProduct
                        classList="single-product mb-30"
                        productName="Liquid Forest Princess"
                        productPrice="03.66 ETH"
                        info="00 : 00 : 00 LEFT"
                      />

                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}

                      <SingleProduct
                        classList="single-product mb-30"
                        productName="Animal Girl Painting"
                        productPrice="1.89 ETH"
                        info="2 to 100"
                      />

                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}

                      <SingleProduct
                        classList="single-product mb-30"
                        productName="Animal Girl Painting"
                        productPrice="3.99 ETH"
                        info="2 to 100"
                      />

                      {/* End Single Product */}
                    </div>
                    <div className="col-lg-12 d-flex justify-content-center mt-30">
                      <NavLink to="#" className="btn">
                        <img
                          src="/img/icons/btn-loadmore.svg"
                          alt=""
                          className="svg"
                        />
                        Load More
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="created">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product4.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Colorful Abstract Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>0.69 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product6.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Animal Girl Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>1.89 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product1.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Liquid Forest Princess</h5>
                            <div className="d-flex justify-content-between">
                              <h6>03.66 ETH</h6>

                              <div className="countdown-wrap">
                                <ul className="countdown">
                                  <li>
                                    <span className="hours">00</span>
                                  </li>
                                  <li className="ms-1 me-1"> : </li>
                                  <li>
                                    <span className="minutes">00</span>
                                  </li>
                                  <li className="ms-1 me-1"> : </li>
                                  <li>
                                    <span className="seconds">00</span>
                                  </li>
                                  <li className="text-uppercase ms-1">left</li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-sm btn-border"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product7.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Animal Girl Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>3.99 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-lg-12 d-flex justify-content-center mt-30">
                      <NavLink to="#" className="btn">
                        <img
                          src="/img/icons/btn-loadmore.svg"
                          alt=""
                          className="svg"
                        />
                        Load More
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="favorited">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product1.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Liquid Forest Princess</h5>
                            <div className="d-flex justify-content-between">
                              <h6>03.66 ETH</h6>

                              <div className="countdown-wrap">
                                <ul className="countdown">
                                  <li>
                                    <span className="hours">00</span>
                                  </li>
                                  <li className="ms-1 me-1"> : </li>
                                  <li>
                                    <span className="minutes">00</span>
                                  </li>
                                  <li className="ms-1 me-1"> : </li>
                                  <li>
                                    <span className="seconds">00</span>
                                  </li>
                                  <li className="text-uppercase ms-1">left</li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-sm btn-border"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product4.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Colorful Abstract Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>0.69 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product6.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Animal Girl Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>1.89 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-md-6">
                      {/* Single Product */}
                      <div className="single-product mb-30">
                        <img src="/img/product/product7.png" alt="" />

                        {/* Product Content */}
                        <div className="product-content">
                          <div className="product-top">
                            <h5>Animal Girl Painting</h5>
                            <div className="d-flex justify-content-between">
                              <h6>3.99 ETH</h6>
                              <h6>2 to 100</h6>
                            </div>
                          </div>

                          <div className="product-bottom">
                            {/* Button Group */}
                            <div className="button-group">
                              <NavLink
                                to="#"
                                className="btn-circle love-react mr-10"
                              ></NavLink>

                              <div className="dropdown mr-10">
                                <button
                                  className="btn-circle btn-border dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <img
                                    src="/img/icons/share.svg"
                                    alt=""
                                    className="svg"
                                  />
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.facebook.com/"
                                    >
                                      <img
                                        src="/img/icons/facebook.svg"
                                        alt=""
                                      />
                                      Share on Facebook
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.twitter.com/"
                                    >
                                      <img
                                        src="/img/icons/twitter.svg"
                                        alt=""
                                      />{" "}
                                      Share on Twitter
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.Instagram.com/"
                                    >
                                      <img
                                        src="/img/icons/instagram.svg"
                                        alt=""
                                      />
                                      Share on Instagram
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      className="dropdown-item"
                                      
                                      to="https://www.linkedin.com/"
                                    >
                                      <img
                                        src="/img/icons/linkedin.svg"
                                        alt=""
                                      />
                                      Share on Linkedin
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>

                              <NavLink
                                to="item-details.html"
                                className="btn btn-border btn-sm"
                              >
                                <img
                                  src="/img/icons/judge-icon.svg"
                                  alt=""
                                  className="svg"
                                />
                                Place Bid
                              </NavLink>
                            </div>
                            {/* End Button Group */}
                          </div>
                        </div>
                        {/* End Product Content */}
                      </div>
                      {/* End Single Product */}
                    </div>
                    <div className="col-lg-12 d-flex justify-content-center mt-30">
                      <NavLink to="#" className="btn">
                        <img
                          src="/img/icons/btn-loadmore.svg"
                          alt=""
                          className="svg"
                        />
                        Load More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              {/* Author Sidebar */}
              <div className="author-sidebar">
                <ProfileCard
                  avatarImgSrc="/img/media/profile-avatar.png"
                  statusImgSrc="/img/icons/check-white.svg"
                  authorName="AneftyPunks"
                  code="69b9ebde0178k7O7&exportsw"
                  facebookLink="https://www.facebook.com/"
                  twitterLink="https://www.twitter.com/"
                  instagramLink="https://www.Instagram.com/"
                  linkedinLink="https://www.linkedin.com/"
                />

                <div className="widget-bio widget card-45">
                  <h3>Anefts Bio</h3>
                  <p>
                    Unique items that you can't replace with something else. for
                    example, NavLink one-of-NavLink-kind trading card is an NFT – you can't
                    just replace it with any other card.
                  </p>
                </div>
              </div>
              {/* End Author Sidebar */}
            </div>
          </div>
        </div>
      </section>
      {/* End Author Profile */}
    
    </>
  );
}

export default Author;
